module.exports = __webpack_public_path__ + "img/question.2ae9ee9d.svg";